import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Inter, JetBrains_Mono } from 'next/font/google'
import { I18nProvider } from '@/lib/i18n/context'
import { ThemeProvider } from '@/lib/theme'
import { DashboardProvider } from '@/lib/store'

const sans = Inter({
    subsets: ['latin', 'latin-ext']
})

const mono = JetBrains_Mono({
    subsets: ['latin']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${sans.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
                <meta name='viewport' content='width=device-width, initial-scale=1' />
            </Head>

            <ThemeProvider>
                <I18nProvider>
                    <DashboardProvider>
                        <Component {...pageProps} />
                    </DashboardProvider>
                </I18nProvider>
            </ThemeProvider>
        </div>
    )
}

export default App
